import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8f4a46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IDESideBarContentTabDownload" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Volby", -1))
const _hoisted_4 = { class: "settings" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Seznam souborů", -1))
const _hoisted_9 = {
  key: 0,
  class: "legend"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Všechny "),
  /*#__PURE__*/_createElementVNode("td", null, "-"),
  /*#__PURE__*/_createElementVNode("td", null, "všechny soubory v daném projektu")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Jen změněné "),
  /*#__PURE__*/_createElementVNode("td", null, "-"),
  /*#__PURE__*/_createElementVNode("td", null, "soubory použité ve videu")
], -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "radioGroup" }
const _hoisted_15 = { class: "radioGroupItem" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fileListAll" }, "Všechny", -1))
const _hoisted_17 = { class: "radioGroupItem" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fileListChangedOnly" }, "Jen změněné", -1))
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "wordWrap" }, "Stav", -1))
const _hoisted_21 = {
  key: 0,
  class: "legend"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Aktuální "),
  /*#__PURE__*/_createElementVNode("td", null, "-"),
  /*#__PURE__*/_createElementVNode("td", null, "stav z aktuálního času videa")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Finální "),
  /*#__PURE__*/_createElementVNode("td", null, "-"),
  /*#__PURE__*/_createElementVNode("td", null, "stav z konce videa")
], -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "radioGroup" }
const _hoisted_27 = { class: "radioGroupItem" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fileStateActual" }, "Aktuální", -1))
const _hoisted_29 = { class: "radioGroupItem" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fileStateFinal" }, "Finální", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-download" }, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Stáhnout")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 0,
  class: "downloads"
}
const _hoisted_35 = {
  key: 0,
  class: "text"
}
const _hoisted_36 = {
  key: 1,
  class: "text"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-spinner fa-spin",
  style: {"animation-duration":"0.5s","animation-iteration-count":"infinite"}
}, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Připravuji...")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

import { ref, withDefaults, watch } from 'vue';

export interface PropsOptions {
	downloads: Array<Download>,
}


export class Download {
	downloadId:string;
	filename:string;
	downloadedSize = 0;
	totalSize:number|null = null;

	constructor(downloadId:string, filename:string) {
		this.downloadId = downloadId;
		this.filename = filename;
	}
}

export interface DownloadOptions {
	fileList: 'all' | 'changedOnly',
	fileState: 'actual' | 'final',
}

export const EmitsOptions = {
	'onDownload' : (downloadOptions: DownloadOptions) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContentTabDownload',
  props: {
    downloads: { default() {
		return [];
	} }
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { downloads: Array<Download> }






const showHelp = ref(false);

const inputFileList = ref("all");
const inputFileState = ref("actual");

function download() {
	emit('onDownload', {
		fileList: inputFileList.value == 'all' ? 'all' : 'changedOnly',
		fileState: inputFileState.value == 'actual' ? 'actual' : 'final',
	});
}

function toggleHelp() {
	showHelp.value = !showHelp.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { class: "showHelp" }, [
          _createElementVNode("span", { onClick: toggleHelp }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (showHelp.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_9, _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "fileList",
                  id: "fileListAll",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputFileList).value = $event)),
                  value: "all"
                }, null, 512), [
                  [_vModelRadio, inputFileList.value]
                ]),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "fileList",
                  id: "fileListChangedOnly",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputFileList).value = $event)),
                  value: "changedOnly"
                }, null, 512), [
                  [_vModelRadio, inputFileList.value]
                ]),
                _hoisted_18
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          (showHelp.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_21, _hoisted_24))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "fileState",
                  id: "fileStateActual",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputFileState).value = $event)),
                  value: "actual"
                }, null, 512), [
                  [_vModelRadio, inputFileState.value]
                ]),
                _hoisted_28
              ]),
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "fileState",
                  id: "fileStateFinal",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputFileState).value = $event)),
                  value: "final"
                }, null, 512), [
                  [_vModelRadio, inputFileState.value]
                ]),
                _hoisted_30
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "action" }, [
      _createElementVNode("button", { onClick: download }, _hoisted_33)
    ]),
    (__props.downloads.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.downloads, (download) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "download",
              key: download.downloadId
            }, [
              (download.totalSize !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(`${Math.round(100 * download.downloadedSize / download.totalSize)}%`), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39)),
              (download.totalSize !== null)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "progress",
                    style: _normalizeStyle({width: `${Math.round(100 * download.downloadedSize / download.totalSize)}%`})
                  }, null, 4))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})